/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { ApplicationStage1DataMktuClassesInner } from './ApplicationStage1DataMktuClassesInner'
import {
  ApplicationStage1DataMktuClassesInnerFromJSON,
  ApplicationStage1DataMktuClassesInnerFromJSONTyped,
  ApplicationStage1DataMktuClassesInnerToJSON,
} from './ApplicationStage1DataMktuClassesInner'

/**
 * Заявка на регистрацию товарного знака (App\Http\Resources\ApplicationResource)
 * @export
 * @interface ApplicationStage1Data
 */
export interface ApplicationStage1Data {
  /**
   * Числовой id заявки
   * @type {number}
   * @memberof ApplicationStage1Data
   */
  id: number
  /**
   *
   * @type {string}
   * @memberof ApplicationStage1Data
   */
  uuid: string
  /**
   * id связанного объекта SysObject
   * @type {number}
   * @memberof ApplicationStage1Data
   */
  sysObj: number
  /**
   * Имя правообладателя из owner_json
   * @type {string}
   * @memberof ApplicationStage1Data
   */
  name: string
  /**
   * Тип правообладателя (UL — юр. лицо, FL — физ. лицо, IP — ИП)
   * @type {string}
   * @memberof ApplicationStage1Data
   */
  ownerType: string
  /**
   *
   * @type {string}
   * @memberof ApplicationStage1Data
   */
  applicationType: string
  /**
   * Ссылка на изображение знака; null, если изображения нет
   * @type {string}
   * @memberof ApplicationStage1Data
   */
  imageUrl?: string | null
  /**
   * Регистрационный номер заявки; для заявок без номера — числовой id
   * @type {string}
   * @memberof ApplicationStage1Data
   */
  applicationNumber: string
  /**
   * Итог регистрации: Issued — знак зарегистрирован, Refused — отказ; null — на этапе регистрации
   * @type {string}
   * @memberof ApplicationStage1Data
   */
  resultStatus?: ApplicationStage1DataResultStatusEnum | null
  /**
   * Фильтровый статус: 1 — экспертиза, 2 — ожидает оплаты, 3 — подготовка к подаче, 4 — завершена
   * @type {number}
   * @memberof ApplicationStage1Data
   */
  filterStatus: ApplicationStage1DataFilterStatusEnum
  /**
   * Заявка опубликована (передана в делопроизводство)
   * @type {boolean}
   * @memberof ApplicationStage1Data
   */
  published: boolean
  /**
   * Выбранные классы МКТУ
   * @type {Array<ApplicationStage1DataMktuClassesInner>}
   * @memberof ApplicationStage1Data
   */
  mktuClasses: Array<ApplicationStage1DataMktuClassesInner>
  /**
   * Имя правообладателя
   * @type {string}
   * @memberof ApplicationStage1Data
   */
  rightholder: string
  /**
   * Адрес правообладателя
   * @type {string}
   * @memberof ApplicationStage1Data
   */
  rightholderAddress: string | null
}

/**
 * @export
 * @enum {string}
 */
export enum ApplicationStage1DataResultStatusEnum {
  Issued = 'Issued',
  Refused = 'Refused',
}
/**
 * @export
 * @enum {string}
 */
export enum ApplicationStage1DataFilterStatusEnum {
  NUMBER_0 = 0,
  NUMBER_1 = 1,
  NUMBER_2 = 2,
  NUMBER_3 = 3,
  NUMBER_4 = 4,
}

/**
 * Check if a given object implements the ApplicationStage1Data interface.
 */
export function instanceOfApplicationStage1Data(
  value: object
): value is ApplicationStage1Data {
  if (!('id' in value) || value['id'] === undefined) return false
  if (!('uuid' in value) || value['uuid'] === undefined) return false
  if (!('sysObj' in value) || value['sysObj'] === undefined) return false
  if (!('name' in value) || value['name'] === undefined) return false
  if (!('ownerType' in value) || value['ownerType'] === undefined) return false
  if (!('applicationType' in value) || value['applicationType'] === undefined)
    return false
  if (
    !('applicationNumber' in value) ||
    value['applicationNumber'] === undefined
  )
    return false
  if (!('filterStatus' in value) || value['filterStatus'] === undefined)
    return false
  if (!('published' in value) || value['published'] === undefined) return false
  if (!('mktuClasses' in value) || value['mktuClasses'] === undefined)
    return false
  if (!('rightholder' in value) || value['rightholder'] === undefined)
    return false
  if (
    !('rightholderAddress' in value) ||
    value['rightholderAddress'] === undefined
  )
    return false
  return true
}

export function ApplicationStage1DataFromJSON(
  json: any
): ApplicationStage1Data {
  return ApplicationStage1DataFromJSONTyped(json, false)
}

export function ApplicationStage1DataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApplicationStage1Data {
  if (json == null) {
    return json
  }
  return {
    id: json['id'],
    uuid: json['uuid'],
    sysObj: json['sysObj'],
    name: json['name'],
    ownerType: json['ownerType'],
    applicationType: json['applicationType'],
    imageUrl: json['imageUrl'] == null ? undefined : json['imageUrl'],
    applicationNumber: json['applicationNumber'],
    resultStatus:
      json['resultStatus'] == null ? undefined : json['resultStatus'],
    filterStatus: json['filterStatus'],
    published: json['published'],
    mktuClasses: (json['mktuClasses'] as Array<any>).map(
      ApplicationStage1DataMktuClassesInnerFromJSON
    ),
    rightholder: json['rightholder'],
    rightholderAddress: json['rightholderAddress'],
  }
}

export function ApplicationStage1DataToJSON(
  value?: ApplicationStage1Data | null
): any {
  if (value == null) {
    return value
  }
  return {
    id: value['id'],
    uuid: value['uuid'],
    sysObj: value['sysObj'],
    name: value['name'],
    ownerType: value['ownerType'],
    applicationType: value['applicationType'],
    imageUrl: value['imageUrl'],
    applicationNumber: value['applicationNumber'],
    resultStatus: value['resultStatus'],
    filterStatus: value['filterStatus'],
    published: value['published'],
    mktuClasses: (value['mktuClasses'] as Array<any>).map(
      ApplicationStage1DataMktuClassesInnerToJSON
    ),
    rightholder: value['rightholder'],
    rightholderAddress: value['rightholderAddress'],
  }
}
